import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { VatDeadline } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import EditVatDeadline from '@/components/vat-deadlines/EditVatDeadline.vue';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        vatDeadline: VatDeadline;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VatDeadlinesTableActions',
  props: {
    vatDeadline: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.vatDeadline }, {
    default: _withCtx(() => [
      (_unref(hasPermission)(_unref(Permission).SYSTEM_UPDATE))
        ? (_openBlock(), _createBlock(EditVatDeadline, {
            key: 0,
            "vat-deadline": _ctx.vatDeadline
          }, null, 8, ["vat-deadline"]))
        : _createCommentVNode("", true),
      (_unref(hasPermission)(_unref(Permission).SYSTEM_DELETE))
        ? (_openBlock(), _createBlock(Delete, {
            key: 1,
            route: _ctx.route('v2.vat-deadlines.destroy', _ctx.vatDeadline.vat_deadline_id),
            "query-key": [_unref(QueryKey).VAT_DEADLINES]
          }, null, 8, ["route", "query-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})